import type { IAccountNotificationsDeals } from './AccountNotificationsDeals.interface';
import AccountNotificationsPreferences from './AccountNotificationsPreferences';

export default class AccountNotificationsDeals implements IAccountNotificationsDeals {
  newMyDeal: AccountNotificationsPreferences;
  newDeal: AccountNotificationsPreferences;
  dealOwnerChanged: AccountNotificationsPreferences;
  dealStageChanged: AccountNotificationsPreferences;
  dealStatusChanged: AccountNotificationsPreferences;
  dealDueDateAhead: AccountNotificationsPreferences;
  dealDueDate: AccountNotificationsPreferences;
  dealOverdue: AccountNotificationsPreferences;
  dealFinanceDueDateAhead: AccountNotificationsPreferences;
  dealFinanceDueDateReached: AccountNotificationsPreferences;
  dealFinanceDueDateOverdue: AccountNotificationsPreferences;
  myDealRotten: AccountNotificationsPreferences;
  dealRotten: AccountNotificationsPreferences;

  static build = (data: IAccountNotificationsDeals) => new AccountNotificationsDeals(data);
  static blank = () => new AccountNotificationsDeals();

  /**
   * Constructor
   * @param {IAccountNotificationsDeals} data
   */
  constructor(data?: IAccountNotificationsDeals) {
    this.newMyDeal = new AccountNotificationsPreferences(data?.newMyDeal);
    this.newDeal = new AccountNotificationsPreferences(data?.newDeal);
    this.dealOwnerChanged = new AccountNotificationsPreferences(data?.dealOwnerChanged);
    this.dealStageChanged = new AccountNotificationsPreferences(data?.dealStageChanged);
    this.dealStatusChanged = new AccountNotificationsPreferences(data?.dealStatusChanged);
    this.dealDueDateAhead = new AccountNotificationsPreferences(data?.dealDueDateAhead);
    this.dealDueDate = new AccountNotificationsPreferences(data?.dealDueDate);
    this.dealOverdue = new AccountNotificationsPreferences(data?.dealOverdue);
    this.dealFinanceDueDateAhead = new AccountNotificationsPreferences(
      data?.dealFinanceDueDateAhead
    );
    this.dealFinanceDueDateReached = new AccountNotificationsPreferences(
      data?.dealFinanceDueDateReached
    );
    this.dealFinanceDueDateOverdue = new AccountNotificationsPreferences(
      data?.dealFinanceDueDateOverdue
    );
    this.myDealRotten = new AccountNotificationsPreferences(data?.myDealRotten);
    this.dealRotten = new AccountNotificationsPreferences(data?.dealRotten);
  }
}
